import { Component, Input, ViewEncapsulation } from '@angular/core';

export enum StatusSnackBarTypes {
  FAIL = 'failed',
  SUCCESS = 'success',
}

@Component({
  selector: 'app-status-snack-bar',
  templateUrl: 'status-snack-bar.component.html',
  styleUrls: ['status-snack-bar.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class StatusSnackBarComponent {
  @Input() message: string = '';
  @Input() submessage: string = '';
  @Input() type: string = '';
  // Use -1 to keep open indefinitely. Currently hardcoded to 5s
  @Input() timeout = 5;

  Types = StatusSnackBarTypes;
}
